import { action, computed, makeAutoObservable, observable } from 'mobx'

import { IRootStore } from 'store/types'
import { PickPointFilesViewModel } from 'sections/LKSection/shared/PickPointSharedModule/models/PickPointFilesViewModel'

import { GetTariffsRequest } from '../../types'
import { OrderLocationViewModel } from '../models/OrderLocationViewModel'
import { OrderWorkConditionsViewModel } from '../models/OrderWorkConditionsViewModel'
import { CreateOrderApiStore } from './CreateOrderApiStore'

export class CreateOrderUiStore {
  @observable selectedStep = 1
  @observable isLoading = false
  @observable hasErrorWithFiles = false
  @observable orderId: number | null = null
  @observable tariff = 0

  @observable agreedWithRequirements = false

  /** Признак переезда */
  @observable exPickPointId: number | null = null

  @observable readonly location = new OrderLocationViewModel()
  @observable readonly fileList = new PickPointFilesViewModel()
  @observable readonly workConditions = new OrderWorkConditionsViewModel()

  @observable readonly apiStore = new CreateOrderApiStore(this)

  constructor(readonly rootStore: IRootStore) {
    makeAutoObservable(this)
  }

  @computed
  get orderStore() {
    return this.rootStore.orderStore
  }

  @computed
  get companyCountry() {
    return this.rootStore.appStore.companyCountry
  }

  @computed
  get getUserPhone() {
    return this.rootStore.appStore.user.info.phone
  }

  @action
  setSelectedStep = (value: number) => {
    this.selectedStep = value
  }

  @action
  setAgreedWithRequirements = (value: boolean) => {
    this.agreedWithRequirements = value
  }

  @action
  setIsLoading = (value: boolean) => {
    this.isLoading = value
  }

  @action
  setExPickPointId = (value: number | null) => {
    this.exPickPointId = value
  }

  @action
  setOrderId = (value: number | null) => {
    this.orderId = value
  }

  @action
  setTariff = (value: number) => {
    this.tariff = value
  }

  @action
  setHasErrorWithFiles = (value: boolean) => {
    this.hasErrorWithFiles = value
  }

  @action
  reset = () => {
    /* 1 шаг */
    this.setAgreedWithRequirements(false)

    /* 2 шаг */
    this.location.reset()

    /* 3 шаг */
    this.workConditions.reset()

    /* 4 шаг */
    this.fileList.reset()

    this.setTariff(0)
    this.setExPickPointId(null)
  }

  @action
  async createOrder() {
    const orderId = await this.apiStore.createOrder()

    return orderId
  }

  @action
  async getTariffs({ area, lat, lon, typePoint }: GetTariffsRequest) {
    return await this.apiStore.getTariffs({ area, lat, lon, typePoint })
  }

  @action
  async publishOrder(orderId: number) {
    return await this.apiStore.publishOrder(orderId)
  }

  @action
  async checkOrderAddress() {
    return await this.apiStore.checkOrderAddress()
  }
}
